'use client'

import CardCarousel from '@/components/common/CardCarousel'
import { ListCardType } from '@/components/common/ListCard'
import { useTranslations } from 'next-intl'
import { usePathname, useSearchParams, useRouter } from 'next/navigation'
import { useEffect, useMemo } from 'react'
import { OfferWithCollection } from './page'

const OfferClient = ({
  offers,
  promo,
}: {
  offers: OfferWithCollection[]
  promo?: string | null
}) => {
  const offerItems = useMemo(() => {
    return offers
      .map((offer): ListCardType | null => {
        if (!offer.slug) return null

        // Use different base path depending on collection type
        const link =
          offer._collection === 'globalOffers'
            ? { pathname: '/offers/[slug]' as const, params: { slug: offer.slug } }
            : { pathname: '/offers/hotel/[slug]' as const, params: { slug: offer.slug } }

        return {
          title: offer.title,
          description: offer.description,
          image: offer.image,
          link,
        }
      })
      .filter((item): item is ListCardType => item !== null)
  }, [offers])

  const t = useTranslations()

  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (promo && searchParams.get('promo') !== promo) {
      const params = new URLSearchParams(searchParams.toString())
      params.set('promo', promo)
      router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    }
  }, [promo, searchParams, pathname, router])

  return (
    <CardCarousel
      title={t('our_best_offers')}
      items={offerItems}
      link={`/offers`}
      linkTitle={t('view_all_offers')}
    />
  )
}

export default OfferClient
